module.exports = __webpack_public_path__ + "media/images/pla/pla9-1364a747149dedbe914c34b9cc049f3d.jpg";